import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class PricesComponent {
    constructor() {
        this.componentSelector = "#affiliates";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        instance.search(instance);

        $('.js-download-excel').off().on('click', function () {
            instance.download(instance);
        });
    }

    search(instance) {
        axios({
            method: 'get',
            url: "/report/GetAffiliates",
            data: {}
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    render(instance, data) {

        if (instance.grid == null) {
            instance.grid = {
                columnDefs: [
                    { headerName: 'Marknad', field: 'MarketId' },
                    { headerName: 'Företag', field: 'CompanyName' },
                    { headerName: 'Affiliatekod', field: 'AffiliateCode' },
                    { headerName: 'Epost', field: 'Email' },
                    { headerName: 'Upplagd av', field: 'SignupReference' },
                    { headerName: 'Skapad', field: 'Created' },
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }

    download(instance) {
        var uri = "/report/GetAffiliatesAsExcel";

        var date = new Date();
        var cache = date.getUTCFullYear() + date.getUTCMonth() + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes() + date.getUTCSeconds() + date.getUTCMilliseconds();
        var fileName = "WKNO-affiliates-" + date.toISOString().split('T')[0] + ".xlsx";

        let query = $('#query').val();

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };

        //var params = JSON.stringify({ sysIds: query });
        //x.setRequestHeader("Content-length", params.length);
        x.send();

        var data = new FormData();
        //data.append('sysIds', query);
        x.send();

        if (typeof (callback) === 'function')
            callback();
    }
}